import { render, staticRenderFns } from "./ColumnFormatting.vue?vue&type=template&id=31b85579&scoped=true&"
import script from "./ColumnFormatting.vue?vue&type=script&lang=ts&"
export * from "./ColumnFormatting.vue?vue&type=script&lang=ts&"
import style0 from "./ColumnFormatting.vue?vue&type=style&index=0&id=31b85579&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31b85579",
  null
  
)

export default component.exports